import * as types from "./types";


export default {
    [types.SET_ADLIST](state, payload) {
        state.adList = payload;
    },
    [types.SET_PLACEMENTLIST](state, payload) {
        state.PlacementList = payload;
    },
    [types.SET_ADOBJECT](state, payload) {
        state.currentAdObject = payload;
    },
    [types.SET_ADDETAILS](state, payload) {
        state.currentAdDetails = payload;
    },
    [types.SET_ENTITIES](state, payload) {
        state.entitiesList = payload;
    },
};
